export default {
    "route": "b47563b2897eca0dd921fe732bed65a61261ab8a0a752a5c7f06307b5edea5ba"
};
